import * as React from 'react';
import { styled } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import ButtonBase from '@material-ui/core/ButtonBase';
import Container from '@material-ui/core/Container';
import Typography from '@material-ui/core/Typography';

import landingIllustration1 from "./../../assets/landing-illustration-1.JPG";

const ImageBackdrop = styled('div')(({ theme }) => ({
  position: 'absolute',
  left: 0,
  right: 0,
  top: 0,
  bottom: 0,
  background: '#000',
  opacity: 0.2,
  transition: theme.transitions.create('opacity'),
}));

const ImageIconButton = styled(ButtonBase)(({ theme }) => ({
  position: 'relative',
  display: 'block',
  padding: 0,
  borderRadius: 0,
  height: '120vh',
  width: '100% !important',
  '&:hover': {
    zIndex: 1,
  },
  '&:hover .imageBackdrop': {
    opacity: 0.1,
  },
  '&:hover .imageMarked': {
    opacity: 0,
  },
  '& .imageMarked': {
    height: 3,
    width: 18,
    background: theme.palette.common.white,
    position: 'absolute',
    bottom: -2,
    left: 'calc(50% - 9px)',
    transition: theme.transitions.create('opacity'),
  },
  [theme.breakpoints.only('xs')]: {
    width: "320px",
    height: "100vh",
  },
  [theme.breakpoints.only('sm')]: {
    width: "568px",
    height: "200vh"
  },
}));

const images = [
  {
    url: landingIllustration1,
    title: 'Respect de nos engagements',
    height: '90%',
    width: '90%',
  }
];

export default function ProductGallery() {
  return (
    <Container component="section" sx={{ mt: 8, mb: 4 }}>
      <Typography variant="h4" marked="center" align="center" component="h2" style={{margin:"2em"}}>
        Le spécialiste de la livraison à vélo cargo dans Paris et sa Petite Couronne.
        <span style={{
          width: "55px",
          height: "4px",
          margin: "2px auto 0",
          display: "block",
          backgroundColor: "#FE6565"
        }}></span>
      </Typography>
      <Box sx={{ mt: 8, display: 'flex', flexWrap: 'wrap' }}>
        {images.map((image) => (
          <ImageIconButton
            key={image.title}
            style={{
              width: image.width,
            }}
          >
            <Box
              sx={{
                position: 'absolute',
                left: 0,
                right: 0,
                top: 0,
                bottom: 0,
                backgroundSize: 'cover',
                backgroundImage: `url(${image.url})`,
              }}
            />
            <ImageBackdrop className="imageBackdrop" />
            <Box
              sx={{
                position: 'absolute',
                left: 0,
                right: 0,
                top: 0,
                bottom: 0,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                color: 'common.white',
              }}
            >
              <div className="imageMarked" />
            </Box>
          </ImageIconButton>
        ))}
      </Box>
    </Container>
  );
}
